import { Text } from "@amzn/stencil-react-components/text";
import styled from "@emotion/styled";
import React, { useId } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row, View } from '@amzn/stencil-react-components/layout';
import { Button } from '@amzn/stencil-react-components/button';
import isEmpty from 'lodash/isEmpty';
import DownloadParentExTemplate from "../components/molecules/DownloadParentExTemplate";

import { IconCrossSmall } from '@amzn/stencil-react-icons';
import { IconUploadSmall } from '@amzn/stencil-react-icons';


const UploadedFileView = styled(View)({
    border: '3px dashed #EEF5F6',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
  });
  
  // View for upload file
  const UploadFileView = styled(View)({
    border: '3px dashed #EEF5F6',
    '&:after': {
      content: '"Drop files here"',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      verticalAlign: 'middle',
      height: '100px',
      color: '#d4d8d8',
    },
  });

const ParentExUploadContainer = ({
    onFileRemove,
    isSubmitted,
    fileContent,
    onClick,
    onFileChange
}) => {
    const {formatMessage} = useIntl();
    return (
        <>
        <Text fontSize="T200">
              <FormattedMessage
                id="app.createSegment.import.filesToImport"
                defaultMessage="Files to import"
              />
            </Text>
            <Text fontSize="T100">
              {' '}
              <FormattedMessage
                id="app.createSegment.import.importFilesText"
                defaultMessage="Choose file."
              />
            </Text>

            {fileContent?.isUploaded ? (
              <UploadedFileView>
                {fileContent?.isUploaded && (
                  <Row alignItems="center" data-testid="parentex-remove-file" onClick={onFileRemove}>
                    {fileContent?.fileName}
                    <IconCrossSmall style={{ cursor: 'pointer' }} aria-hidden={true} />
                  </Row>
                )}
              </UploadedFileView>
            ) : (
              <UploadFileView
                className={isSubmitted && isEmpty(fileContent?.content) ? 'error' : ''}
              >
                {fileContent?.isUploaded && (
                  <Row alignItems="center" data-testid="parentex-remove-file" onClick={onFileRemove}>
                    {fileContent?.fileName}
                    <IconCrossSmall style={{ cursor: 'pointer' }} aria-hidden={true} />
                  </Row>
                )}
              </UploadFileView>
            )}
            {isSubmitted &&
              isEmpty(fileContent?.content) && (
                <Text className="errorText">
                  <FormattedMessage
                    id="app.createSegment.import.fileUploadErrorMessage"
                    defaultMessage="File is empty/invalid. Please upload a valid csv file."
                  />
                </Text>
              )}
            <Text>
              <FormattedMessage
                id="app.createSegment.import.orChooseBelow"
                defaultMessage="Or Choose below"
              />
            </Text>
            <Row gridGap="S300">
              <Col width="30%">
                <input
                  type="file"
                  style={{ display: 'none' }}
                  id="parent_ex_file"
                  data-testid="parentex-file-upload-input"
                  onChange={onFileChange}
                  accept={'.csv'}
                />
                <Button
                  hasIcon
                  variant="tertiary"
                  onClick={onClick}
                  disabled={fileContent?.isUploaded}
                >
                  <Row gridGap="S200" alignItems="center">
                    <IconUploadSmall
                      title={formatMessage({ id: 'app.createSegment.chooseFileLabel' })}
                      aria-hidden={true}
                    />
                    <FormattedMessage
                      id="app.createSegment.chooseFileLabel"
                      defaultMessage="Choose File"
                    />
                  </Row>
                </Button>
              </Col>
              <Col width="30%">
                <View display="flex" alignItems="center">
                  <DownloadParentExTemplate />
                </View>
              </Col>
            </Row>
        </>
    )
}

export default ParentExUploadContainer;